import { Box, Grid, useColorMode, useDisclosure } from '@chakra-ui/react'
import { InitialConfigType, LexicalComposer } from '@lexical/react/LexicalComposer'
import LexicalErrorBoundary from '@lexical/react/LexicalErrorBoundary'
import { RichTextPlugin } from '@lexical/react/LexicalRichTextPlugin'
import { FC } from 'react'
import { ContentEditable } from 'shared/components/Lexical/components/ContentEditable'
import { EditorEmojiPicker2 } from 'shared/components/Lexical/components/EditorEmojiPicker2'
import { Placeholder } from 'shared/components/Lexical/components/Placeholder'
import { EmojiNode } from 'shared/components/Lexical/nodes/EmojiNode'
import { UploadNode } from 'shared/components/Lexical/nodes/UploadNode'
import { EmojiPickerPlugin } from 'shared/components/Lexical/plugins/EmojiPickerPlugin'
import { EmojiPlugin } from 'shared/components/Lexical/plugins/EmojiPlugin'
import { WhatsAppUploadPlugin } from 'shared/components/Lexical/plugins/WhatsAppUploadPlugin'
import theme from 'shared/components/Lexical/theme'

import { SMSMessageToolbar } from './SMSMessageToolbar'
import { SMSSendMessagePlugin, SMSSendMessagePluginProps } from './SMSSendMessagePlugin'
import { WhatsAppMessageToolbar } from './WhatsAppMessageToolbar'

const config: InitialConfigType = {
    namespace: 'SMSMessageInput',
    nodes: [EmojiNode, UploadNode],
    theme: theme,
    onError(error) {
        throw error
    }
}

export const SMSMessageInput: FC<SMSSendMessagePluginProps> = ({
    onSendMessage,
    channelID,
    isWhatsApp,
    template,
    isReadOnly,
    limitExceeded
}) => {
    const { colorMode } = useColorMode()
    const emojiPicker = useDisclosure()

    return (
        <LexicalComposer initialConfig={config}>
            <Grid
                templateColumns={'1fr min-content'}
                position="relative"
                w="full"
                minH={'94px'}
                alignItems={'start'}
                px="16px"
                bg={`${colorMode}.tones.ghostWhite`}
                border="1px solid"
                borderColor={`${colorMode}.tones.periwinkle`}
                borderRadius="8px"
            >
                <Box>
                    <EditorEmojiPicker2 disclosure={emojiPicker} />
                    <RichTextPlugin
                        contentEditable={
                            <ContentEditable py="12px" data-testid="SMSBox-content-editable" />
                        }
                        placeholder={limitExceeded ? null : <Placeholder />}
                        ErrorBoundary={LexicalErrorBoundary}
                    />
                    {isWhatsApp ? (
                        <WhatsAppMessageToolbar
                            channelID={channelID}
                            limitExceeded={limitExceeded}
                            template={template}
                        />
                    ) : (
                        <SMSMessageToolbar limitExceeded={limitExceeded} />
                    )}
                </Box>
                <EmojiPlugin />
                <EmojiPickerPlugin disclosure={emojiPicker} />
                {isWhatsApp && <WhatsAppUploadPlugin />}
                <SMSSendMessagePlugin
                    onSendMessage={onSendMessage}
                    channelID={channelID}
                    template={template}
                    isWhatsApp={isWhatsApp}
                    isReadOnly={isReadOnly}
                    limitExceeded={limitExceeded}
                />
            </Grid>
        </LexicalComposer>
    )
}
